export default __webpack_public_path__ + "RINF-User Manual v2.2.1.pdf";